import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'
import { LabelVariant } from './Label.types'

export const LabelContainer = styled('div')<{
    theme?: TTheme
    variant?: LabelVariant
}>`
    display: flex;
    gap: 4px;
    background-color: ${({ theme, variant }) => {
        if (variant === 'error') {
            return theme?.colors.semantic.errorLight
        }
        if (variant === 'info') {
            return theme?.colors.greys[100]
        }
        return theme?.colors.semantic.reason
    }};
    padding: 4px 9px;
`
